import {
    Card,
    Input,
    Typography,
    Space,
    Button,
    Tag,
    message,
} from "antd";
import { useState } from "react";

const { Text, Title } = Typography;

interface EmailListSettingCardProps {
    title: string;
    description?: string;
    value: string[];
    onChange: (emails: string[]) => void;
    onSave: () => void;
    isDirty: boolean;
}

const emailRegex =
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const EmailListSettingCard: React.FC<EmailListSettingCardProps> = ({
    title,
    description,
    value,
    onChange,
    onSave,
    isDirty,
}) => {
    const [input, setInput] = useState("");

    const addEmail = () => {
        const email = input.trim().toLowerCase();

        if (!emailRegex.test(email)) {
            message.error("Please enter a valid email address");
            return;
        }

        if (value.includes(email)) {
            message.warning("Email already added");
            return;
        }

        onChange([...value, email]);
        setInput("");
    };

    const removeEmail = (email: string) => {
        onChange(value.filter((e) => e !== email));
    };

    return (
        <Card>
            <Space direction="vertical" size={12} style={{ width: "100%" }}>
                <Title level={5} style={{ margin: 0 }}>
                    {title}
                </Title>

                {description && (
                    <Text type="secondary">{description}</Text>
                )}

                {/* Input */}
                <Input
                    size="large"
                    placeholder="Enter email and press Add"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onPressEnter={addEmail}
                    style={{ height: 45 }}
                    styles={{
                        input: { height: "100%" },
                    }}
                    addonAfter={
                        <Button type="link" onClick={addEmail} style={{ height: '34px' }}>
                            Add
                        </Button>
                    }
                />


                {/* Email list */}
                <Space wrap>
                    {value.map((email) => (
                        <Tag
                            key={email}
                            closable
                            onClose={() => removeEmail(email)}
                        >
                            {email}
                        </Tag>
                    ))}
                </Space>

                {/* Actions */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: 8,
                    }}
                >
                    <Button
                        type="primary"
                        onClick={onSave}
                        disabled={!isDirty}
                    >
                        Save
                    </Button>
                </div>
            </Space>
        </Card>
    );
};
